// Nikura Custom Code - Header, MISTI pill, product gallery and reviews events - Start
// Colleagues' tracking sheet 12fQI2GIr--PPuhdRlWcwHGRcE0g8g4mwC1ctyWbuf5U rows 18-25, 27 (columns E-H).
// Pushes one flat dataLayer event per interaction (the house 'NK dL' field style); GTM custom-event
// triggers map each event to a GA4 tag.
//   header_menu_open         - header burger (three-line) button          (every page)
//   header_search_open       - header search (magnifier) button           (every page)
//   header_logo_click        - header NIKURA wordmark                     (every page)
//   header_account_click     - header account icon                        (every page)
//   header_cart_click        - header bag icon                            (every page)
//   nav_pill_click           - black 'MISTI DIFFUSER' pill in the nav row (every page)
//   pdp_gallery_interaction  - product photo changed by thumbnail, dot or swipe (product pages)
//   pdp_reviews_filter       - reviews FILTERS opened/closed, star rating ticked/unticked, review search
//   pdp_write_review_click   - reviews WRITE A REVIEW button              (product pages)
// Runs side by side with the older burger_menu_click / search_icon_click / product_image_select /
// product_review_filters_open tags; it does not touch them.
// Strict no-op: each listener only acts on its own element; nothing on the page is changed. No network
// calls, no customer data (logged_in is a yes/no only). SKUs come from data Shopify already printed.

(function () {
  'use strict';

  if (window.__nkHdrGalRevInstalled) return;
  window.__nkHdrGalRevInstalled = true;

  var IS_PDP = window.location.pathname.indexOf('/products/') !== -1;

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function push(event, fields) {
    var payload = { event: event };
    for (var k in fields) if (Object.prototype.hasOwnProperty.call(fields, k)) payload[k] = fields[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  // ---- page facts already on the page ----
  function meta() { return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {}; }
  function pageType() {
    var t = (meta().page && meta().page.pageType) || '';
    if (t === 'searchresults') return 'search';
    return t || (window.location.pathname === '/' ? 'home' : 'other');
  }
  function loggedIn() { return meta().page && meta().page.customerId ? 'true' : 'false'; }
  function cartCount() {
    try {
      var c = window.Alpine && window.Alpine.store && window.Alpine.store('cart');
      if (c && typeof c.count === 'number') return c.count;
    } catch (_) {}
    var n = Number(text(document.querySelector('#header .cart-item-counts')));
    return isNaN(n) ? 0 : n;
  }
  function pathOf(href) {
    try { var u = new URL(href, window.location.href); return u.host === window.location.host ? u.pathname : u.href; }
    catch (_) { return href || ''; }
  }
  function headerFields() {
    return { location_id: 'header', page_type: pageType(), page_path: window.location.pathname };
  }

  // ---- product (same source as the 6 Oct product page file) ----
  function buyBoxSelected() {
    var atc = document.getElementById('addToCart');
    for (var el = atc; el; el = el.parentElement) {
      var stack = el._x_dataStack;
      if (!stack) continue;
      for (var i = 0; i < stack.length; i++) {
        var sel = stack[i] && stack[i].product && stack[i].product.selected;
        if (sel && sel.id) return sel;
      }
    }
    return null;
  }
  function product() {
    var p = meta().product;
    var live = buyBoxSelected();
    var vid = live ? String(live.id) : String(meta().selectedVariantId || '');
    var variant = null;
    if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === vid) { variant = p.variants[i]; break; }
      }
    }
    return {
      item_id: (variant && variant.sku) || (live && live.sku) || vid || (p ? String(p.id) : ''),
      item_name: text(document.querySelector('h1'))
    };
  }

  // ---- header + pill (every page). Capture phase: the menu/search buttons stop their own clicks. ----
  function headerClick(t) {
    if (!closest(t, '#header')) return false;
    if (closest(t, 'button.mobile-drawer-btn')) { push('header_menu_open', headerFields()); return true; }
    if (closest(t, '#header button[aria-label="Search"]')) { push('header_search_open', headerFields()); return true; }
    if (closest(t, '#header a[aria-label="Nikura Logo"]')) { push('header_logo_click', headerFields()); return true; }
    if (closest(t, '#header a[aria-label="Account Login"]')) {
      var a = headerFields(); a.logged_in = loggedIn(); push('header_account_click', a); return true;
    }
    if (closest(t, '#header a[aria-label="Open Minicart"]')) {
      var c = headerFields(); c.cart_item_count = cartCount(); push('header_cart_click', c); return true;
    }
    return false;
  }
  function pillClick(t) {
    var a = closest(t, 'a.mobile-nav-link-misti-diffuser');
    if (!a) return false;
    push('nav_pill_click', { location_id: 'main_nav_pill', link_text: text(a), link_url: pathOf(a.getAttribute('href')),
      page_type: pageType() });
    return true;
  }

  // ---- product gallery (Alpine `images` state drives the photo swiper) ----
  var GALLERY = '#product-images';
  var galleryCause = null; // {type, at, from}
  function imagesState() {
    var root = document.querySelector(GALLERY);
    for (var el = root; el; el = el.parentElement) {
      var stack = el._x_dataStack;
      if (!stack) continue;
      for (var i = 0; i < stack.length; i++) if (stack[i] && stack[i].images) return stack[i].images;
    }
    return null;
  }
  function slideIsVideo(index) {
    var root = document.querySelector(GALLERY);
    var slides = root ? root.querySelectorAll('.swiper-slide') : [];
    var s = slides[index];
    return !!(s && s.querySelector('video, iframe'));
  }
  // Wait (max 2 s) until the photo shown really changes, then report it once.
  function watchGallery(type, from) {
    var cause = { type: type, at: Date.now(), from: from };
    galleryCause = cause;
    var start = Date.now();
    (function tick() {
      if (galleryCause !== cause) return;
      var st = imagesState();
      var now = st ? Number(st.current) : NaN;
      if (!isNaN(now) && now !== from) {
        galleryCause = null;
        var f = { location_id: 'pdp_gallery', interaction_type: type, direction: now > from ? 'next' : 'prev',
          image_index: now + 1, is_video: slideIsVideo(now) ? 'true' : 'false', item_id: product().item_id };
        push('pdp_gallery_interaction', f);
        return;
      }
      if (Date.now() - start > 2000) { galleryCause = null; return; }
      setTimeout(tick, 80);
    })();
  }
  function galleryClick(t) {
    if (!IS_PDP) return false;
    var st = imagesState();
    if (!st) return false;
    var li = closest(t, '#product-mobile-thumbs li, #product-thumbs li');
    if (li) {
      var m = /images\.goTo\(\s*(\d+)\s*\)/.exec(li.getAttribute('@click') || li.getAttribute('x-on:click') || '');
      if (m && Number(m[1]) !== Number(st.current)) watchGallery('thumbnail', Number(st.current));
      return true;
    }
    if (closest(t, '#image-container .swiper-pagination-bullet')) { watchGallery('dot', Number(st.current)); return true; }
    return false;
  }
  var swipeFrom = null, swipeX = 0;
  function touchX(e) { var t = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]); return t ? t.clientX : 0; }
  function galleryTouchStart(e) {
    if (!IS_PDP || !closest(e.target, GALLERY)) { swipeFrom = null; return; }
    var st = imagesState();
    swipeFrom = st ? Number(st.current) : null;
    swipeX = touchX(e);
  }
  function galleryTouchEnd(e) {
    if (swipeFrom === null || !closest(e.target, GALLERY)) return;
    var from = swipeFrom; swipeFrom = null;
    if (Math.abs(touchX(e) - swipeX) < 20) return; // a tap, not a swipe
    if (galleryCause && Date.now() - galleryCause.at < 600) return; // a dot/thumbnail tap already owns it
    watchGallery('swipe', from);
  }

  // ---- reviews (Okendo widget, two copies on the page; only the visible one is used) ----
  function reviewsClick(t) {
    if (!IS_PDP) return false;
    var toggle = closest(t, 'button[aria-controls="filter-options"]');
    if (toggle) {
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      push('pdp_reviews_filter', { location_id: 'pdp_reviews', action: opening ? 'open' : 'close', filter_type: 'panel',
        filter_value: opening ? 'open' : 'close', item_id: product().item_id });
      return true;
    }
    if (closest(t, 'a.oke-w-writeReview')) {
      var p = product();
      push('pdp_write_review_click', { location_id: 'pdp_reviews', item_id: p.item_id, item_name: p.item_name });
      return true;
    }
    return false;
  }
  function reviewsChange(e) {
    var t = e.target;
    if (!IS_PDP || !t || !closest(t, '#filter-options')) return;
    if (t.matches && t.matches('input.oke-w-filterOption-checkbox')) {
      var stars = /(\d+)/.exec(t.getAttribute('name') || '');
      push('pdp_reviews_filter', { location_id: 'pdp_reviews', action: t.checked ? 'apply' : 'remove',
        filter_type: 'star_rating', filter_value: stars ? stars[1] : text(t.parentElement), item_id: product().item_id });
    } else if (t.matches && t.matches('input.oke-w-textSearchFilter-input')) {
      var term = (t.value || '').trim().slice(0, 50);
      push('pdp_reviews_filter', { location_id: 'pdp_reviews', action: term ? 'apply' : 'remove',
        filter_type: 'text_search', filter_value: term, item_id: product().item_id });
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    try { headerClick(t) || pillClick(t) || galleryClick(t) || reviewsClick(t); } catch (_) {}
  }, true);
  document.addEventListener('change', function (e) { try { reviewsChange(e); } catch (_) {} }, true);
  if (IS_PDP) {
    document.addEventListener('touchstart', function (e) { try { galleryTouchStart(e); } catch (_) {} }, { capture: true, passive: true });
    document.addEventListener('touchend', function (e) { try { galleryTouchEnd(e); } catch (_) {} }, { capture: true, passive: true });
  }
})();
// Nikura Custom Code - Header, MISTI pill, product gallery and reviews events - End
